import "./Consultant.scss";
import avatar from "../../Assets/mario-konsultan.png";

const Consultant = () => {
  const waOpen = () => {
    window.open(
      "https://api.whatsapp.com/send/?phone=6281212356556&text=Halo+Mario,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Summarecon%20Tangerang?%20http://marketingrumahtangerang.id/&type=phone_number&app_absent=0",
      "_blank",
    );
  };

  return (
    <section id="consultant" className="section-consultant">
      <div className="consultant-container">
        <div className="consultant-card">
          <div className="consultant-avatar">
            <img src={avatar} alt="Property Consultant" />
          </div>
          <div className="consultant-info">
            <h2 className="consultant-title">
              Butuh Bantuan? Hubungi Konsultan Kami
            </h2>
            <h3 className="consultant-name">Mario Wibisono</h3>
            <p className="consultant-role">Consultant PT Asia Rumah Utama</p>
            <p className="consultant-desc">
              Hallo saya Mario, Mitra Resmi Pemasaran Properti Summarecon
              Tangerang, Informasi dari Website ini berasal dari PT Asia Rumah
              Utama, yang di ambil dari Informasi Properti Summarecon Tangerang,
              Untuk Informasi lebih jelas Hubungi Saya mengenai Simulasi
              Cicilan, Brosur & Pricelist.
            </p>
            <button onClick={waOpen} className="btn-consultant">
              Tanya via WhatsApp
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Consultant;
